import { Event } from "event-system";
import { Container, Sprite, Texture } from "pixi.js";
import gsap from "gsap";
import { NFT } from "by/gamefactory/web3/nfts/NFT";

export class NFTScrollItem extends Container {
    public readonly onCollect: Event<NFTScrollItem>;
    public readonly onClick: Event<NFTScrollItem>;
    public readonly data: NFT;

    private static readonly IMAGE_SIDE_SIZE = 500;

    protected readonly image: Sprite;

    public constructor(nftImage: Texture, data: NFT) {
        super();
        this.image = new Sprite(nftImage);
        this.data = data;
        this.image.width = this.image.height = NFTScrollItem.IMAGE_SIDE_SIZE;
        this.addChild(this.image);
        this.onCollect = new Event<NFTScrollItem>();
        this.onClick = new Event<NFTScrollItem>();
    }

    public async hide(): Promise<void> {
        const animation = new gsap.core.Timeline();
        const duration = 0.5;
        animation.fromTo(this, { alpha: this.alpha }, { alpha: 0, duration: duration, ease: "power1.inOut" });
        await animation.play();
        animation.kill();
    }
}
